import { Am, En, Ru } from '../../../assets/icons';
import { Language } from '../../../consts/locale';

export const languages = [
	{
		id: 1,
		value: Language.En,
		label: 'ENG',
		flag: En,
	},
	{
		id: 2,
		value: Language.Ru,
		label: 'RUS',
		flag: Ru,
	},
	{
		id: 3,
		value: Language.Hy,
		label: 'ARM',
		flag: Am,
	},
];
